<script lang="ts">
  import { fade } from "svelte/transition";
  import { productsStore, currentRoute } from "../store";

  let showSuccessMsg = false;

  function navigate(route: string, e: Event): void {
    e.preventDefault();
    $currentRoute = route;
  }

  function handleBuyNow(e: Event) {
    e.preventDefault();
    showSuccessMsg = true;
    setTimeout(() => {
      showSuccessMsg = false;
    }, 4000);
  }
</script>

<div class="w-full p-6 relative">
  {#if showSuccessMsg}
    <div
      class="fixed top-28 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-8 py-5 rounded-xl shadow-2xl z-50 flex items-center transition-opacity border-b-8 border-green-700"
      transition:fade
    >
      <i class="fa-solid fa-check-circle text-4xl mr-5"></i>
      <div>
        <p class="text-2xl font-black uppercase tracking-wide">Thank You!</p>
        <p class="text-base font-medium mt-1">
          Your purchase has been processed successfully.
        </p>
      </div>
      <button
        class="ml-8 text-2xl hover:text-black transition"
        on:click={() => (showSuccessMsg = false)}
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  {/if}

  <div
    class="flex justify-between items-center mb-6 max-sm:flex-col max-sm:items-start max-sm:gap-4"
  >
    <h2
      class="text-5xl font-black uppercase tracking-wider text-gray-800 drop-shadow-sm"
    >
      Our Products
    </h2>
    <a
      href="/#"
      on:click={(e) => navigate("Admin", e)}
      class="bg-sky-500 text-white font-bold py-3 px-6 rounded-lg transition duration-400 hover:scale-110 hover:bg-amber-400 hover:text-black hover:shadow-xl max-sm:w-full max-sm:text-center text-lg"
      >Manage Products</a
    >
  </div>

  <hr class="h-px mb-8 bg-gray-300 border-0" />

  <div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-8"
  >
    {#each $productsStore as product (product.id)}
      <div
        class="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition duration-400 border-4 border-sky-400 hover:border-amber-400 hover:-translate-y-2 flex flex-col cursor-pointer"
      >
        <img
          src={product.image}
          alt={product.name}
          class="w-full h-56 object-cover"
        />
        <div class="p-5 flex-1 flex flex-col">
          <h3 class="text-xl font-bold mb-2 line-clamp-1">{product.name}</h3>
          <p class="text-gray-600 mb-4 line-clamp-2 flex-1">
            {product.description}
          </p>
          <div class="flex justify-between items-center mt-2">
            <span class="text-2xl font-bold text-sky-600"
              >${product.price.toFixed(2)}</span
            >
            <button
              on:click={handleBuyNow}
              class="bg-amber-400 text-black px-4 py-2 rounded-lg font-bold hover:bg-sky-500 hover:text-white transition duration-300 shadow hover:shadow-lg"
              >Buy Now</button
            >
          </div>
        </div>
      </div>
    {/each}
  </div>
</div>
